import React, { useCallback, useContext, useMemo, useState } from "react";
import { Box, Dialog, DialogContent, FormControl, FormControlLabel, FormLabel, InputAdornment, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import ModAccName from 'components/ModAccName';
import { DialogFooter, DialogHeader } from 'components/dialog/DialogHeader';
import { initDialogData } from "../pages/Menu3/AddJobOrderExpense/initData";
import { validate } from "utils";
import PaperComponent from "components/PaperComponent";
import { useEffect } from "react";
import ComboBox from "components/ComboBox";
import { expenseJobOrderApiNm, expenseJobOrderColNm } from "constants/expenseJobOrderConstant";
// import useFinanceMsData from "hooks/useFinanceMsData";
import { BoxFR } from "components/BoxCustom";
import useDialogOpen from "hooks/useDialogOpen";
import {  grey } from "@mui/material/colors";
import { GlobalStateContext } from "contexts/GlobalStateContext";


/**
 * AS 2025-05-08 this Dialog use in only for subcontract 
 * After change expid get data from expPoi
 */
const ExpenseJobOrderDialog = ({ state, fn, getApiName }) => {
  const { msData } = useContext(GlobalStateContext);
  // const { msData } = useFinanceMsData();

  const { dialogOpen, selectedExpId, joData } = state
  const { setDialogOpen, deleteExpenseJobOrder, insertUpdateExpenseJobOrder } = fn
  const [dialogData, setDialogData] = useState(initDialogData)


  const apiName = getApiName || expenseJobOrderApiNm.getExpenseJobOrder;
  const key = apiName === expenseJobOrderApiNm.getExpenseJobOrder ? "ExpJobOrdId" : "ScExpId"
  
  useDialogOpen(dialogOpen, selectedExpId, apiName, key, setDialogData, initDialogData)

  const validation = useMemo(() => ({
    ExpNm: dialogData.ExpNm === ''
  }), [dialogData]);

  const comboProp = useCallback((name, label, options) => ({
    options: options,
    label: label,
    required: true,
    disabled: selectedExpId !== 0,
    sx: { width: "100%" },
    selectedId: dialogData.ExpId,
    setSelectedId: (id) => setDialogData(o => {
     
      const found = msData.expensePOIs?.find(exp => (!exp.ExpId || exp.ExpId === id)
        && (!exp.JobId || exp.JobId === joData.JobId)
        && (!exp.POIId || [joData.TakePOIId, joData.LocPOIId, joData.RtnPOIId].includes(exp.POIId))
        && (!exp.ContSize || exp.ContSize === joData.ContSize)
        && (!exp.ContType || exp.ContType === joData.ContType)
        && (!exp.ShpmTypId || exp.ShpmTypId === joData.ShpmTypId)
        && (!exp.TlrTypId || exp.TlrTypId === joData.TlrTypId)
      )
     
      const vatPrct = +(found?.VatPrct || 0)
      const whtPrct = +(found?.WhtPrct || 0)
      if (found) {
        return {
          ...o,
          ExpId: id,
          IsCost: found.IsCost,
          UntPrB4Vat: Math.round(found.UntPr / (1 + +vatPrct / 100) * 100) / 100,
          UntPr: found.UntPr,
          VatPrct: vatPrct,
          WhtPrct: whtPrct,
          IsOwnRcpt: found.IsOwnRcpt
        }
      }

      const expObj = msData.expObj[id]
      if (expObj) {

        return {
          ...o,
          ExpId: id,
          UntPrB4Vat: Math.round(expObj.UntPr / (1 + +(expObj.VatPrct || 0) / 100) * 100) / 100,
          UntPr: expObj.UntPr,
          VatPrct: expObj.VatPrct,
          WhtPrct: expObj.WhtPrct,
          IsOwnRcpt: expObj.IsOwnRcpt
        }
      }
      return { ...o, ExpId: id }

    })
  }), [dialogData, msData, setDialogData, selectedExpId, joData])

  const dialogDataProp = useCallback((name) => ({
    variant: 'outlined',
    size: 'small',
    name: name,
    label: expenseJobOrderColNm[name] ,
    value: dialogData[name]?? "",
    error: validation[name],
    onChange: (e) => {
      setDialogData((oldState) => {
        let total = oldState.Total
        if (e.target.name === "Qty") {
          total = oldState.UntPr * e.target.value
        } else if (e.target.name === "UntPr") {
          total = oldState.Qty * e.target.value
        }
        return { ...oldState, [name]: e.target.value, Total: total }
      })
    }
  }), [dialogData, validation])

  const calculateVat = useCallback((isB4Vat) => (e) => {
    setDialogData(o => {
      const amnt = +e.target.value
      const newAmnt = isB4Vat ? amnt + amnt * +o.VatPrct / 100 : amnt / (1 + +o.VatPrct / 100)
      if (isB4Vat) {
        return { ...o, UntPr: Math.round(newAmnt * 100) / 100, Total: newAmnt * +o.Qty }
      } else {
        return { ...o, UntPrB4Vat: Math.round(newAmnt * 100) / 100, Total: amnt * +o.Qty }
      }
    })
  }, [])
  useEffect(() => {
    if (dialogOpen === false) {
      setDialogData(initDialogData)
    }
  }, [dialogOpen])

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='xs' >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="ค่าใช้จ่าย"
        onDeleteClick={selectedExpId > 0 ? () => deleteExpenseJobOrder(selectedExpId) : null}
      />
      <DialogContent>
        <Box display='flex' flexDirection='column' gap={2} mt={2}>
          <ComboBox {...comboProp("ExpId", expenseJobOrderColNm.ExpNm, msData.expCombo)} />
          {/* <TextField {...dialogDataProp('IsCost')} select fullWidth label="รายได้-ต้นทุน" disabled={selectedExpId !== 0}
            required sx={{ bgcolor: dialogData.IsCost ? red[50] : green[50] }}>
            <MenuItem value={0}>รายได้</MenuItem>
            <MenuItem value={1}>ต้นทุน</MenuItem>
          </TextField> */}
          <TextField {...dialogDataProp('UntPrB4Vat')} sx={{ backgroundColor: grey[200] }} type="number" label={<Typography>ราคา {<strong>ก่อน</strong>} Vat</Typography>} onBlur={calculateVat(true)} inputProps={{ style: { textAlign: "right" } }} />

          <TextField {...dialogDataProp('UntPr')} type="number" label={<Typography>ราคา {<strong>หลัง</strong>} Vat</Typography>} onBlur={calculateVat(false)} inputProps={{ style: { textAlign: "right" } }} />
          <TextField {...dialogDataProp('Qty')} inputProps={{ style: { textAlign: "right" } }} />
          <TextField {...dialogDataProp('Total')} inputProps={{ style: { textAlign: "right" } }} disabled />
          <BoxFR>
            <TextField {...dialogDataProp('VatPrct')} sx={{ flexGrow: 1 }} inputProps={{ style: { textAlign: "right" } }}
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }} />
            <TextField {...dialogDataProp('WhtPrct')} sx={{ flexGrow: 1 }} inputProps={{ style: { textAlign: "right" } }}
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }} />
          </BoxFR>
          {
            !dialogData.IsCost &&

            <FormControl component="fieldset">
              <FormLabel component="legend">{expenseJobOrderColNm.IsOwnRcpt}</FormLabel>
              <RadioGroup row name='IsOwnRcpt' value={dialogData.IsOwnRcpt}
                onChange={(e) => { setDialogData((oldState) => ({ ...oldState, IsOwnRcpt: e.target.value })) }}>
                <FormControlLabel value={1} control={<Radio />} label="ใบเสร็จบริษัท" />
                <FormControlLabel value={0} control={<Radio />} label="ใบเสร็จลูกค้า" />
              </RadioGroup>
            </FormControl>
          }
          <TextField {...dialogDataProp('Rmk')} multiline rows={3} />
          {
            dialogData.selectedExpId > 0 && <ModAccName modDte={dialogData.ModDte} modAcc={dialogData.ModAcc} />
          }
        </Box>
      </DialogContent>
      <DialogFooter okText={selectedExpId > 0 ? "แก้ไขข้อมูล" : "เพิ่มข้อมูล"}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={() => validate(validation) && insertUpdateExpenseJobOrder(dialogData)} />
    </Dialog>
  )
}

export default React.memo(ExpenseJobOrderDialog)